<template>
  <div>
    <h1>
      Empresa
      <br />
      <br />
    </h1>

    <template>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="w-full" label="Nombre" v-model="company.name" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="w-full" label="Dirección" v-model="company.address" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="w-full" label="RTN" v-model="company.rtn" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="w-full" label="CAI" v-model="company.cai" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="w-full" label="Logo" v-model="company.logo" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="w-full" label="Observación" v-model="company.observation" />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" v-on:click="updateCompany">Actualizar</vs-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      company: {
        name: "",
        address: "",
        rtn: "",
        cai: "",
        logo: "",
        observation: ""
      },
      colorAlert: "primary",
      titleAlert: "Alert",
      activeAlert: false,
      valueInput: ""
    };
  },
  methods: {
    updateCompany() {
      const path = `/company/1/`;

      console.info(this.company);

        this.$http.patch(path, {
            id:    this.company.id,
            name:    this.company.name ,
            address:    this.company.address ,
            rtn:    this.company.rtn , 
            cai:    this.company.cai , 
            logo:  this.company.logo ,
            observation:    this.company.observation ,
            deleted_at:    this.company.deleted_at ,
            is_deleted:    this.company.is_deleted ,

        })
        .then(response => {
          if (response.data) {
            this.company = response.data;
            // this.openAlert('success')
            this.$vs.notify({
              title: "Operación Correcta",
              text: "Los cambios se ejecutaron exitósamente",
              color: "success"
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.$vs.notify({
            title: "Operación Fallida",
            text: "Los cambios no pudieron ser procesados por el servidor",
            color: "danger"
          });
        });
    },
    getCompany() {
      const path = `/company/1/`;
      this.$http
        .get(path)
        .then(response => {
          this.company = response.data;
          console.log(this.company);
        })
        .catch(error => {
          console.log(error);
        });
    },

    openAlert(color) {
      this.colorAlert = color || this.getColorRandom();
      this.$vs.dialog({
        color: this.colorAlert,
        title: "Cambios realizados exitósamente",
        // text: 'OK',
        accept: this.acceptAlert
      });
    }
  },
  created() {
    this.getCompany();
  }
};
</script>

